import HomeBanner from "../../components/HomeBanner";
import HomeContent from "../../components/HomeContent";
import useFeature from "../../useFeature";
import {HomeFeature} from "./HomeFeature";
import {useApplication} from "../../ApplicationProvider";
import {observer} from "mobx-react";

function HomeScreen() {
    const application = useApplication()
    const feature = useFeature(() => new HomeFeature(application))
    const isFeatureReady = (feature) => {
        return feature && feature.loaded
    }

    return isFeatureReady(feature) && (<div>
            <HomeBanner featuredProductsLine={feature.featuredProductsLine}/>
            <HomeContent overdueBalance={feature.AlertaSaldoVencido} productsLines={feature.categories}
                         initialOrder={feature.PedidoInicial} products={feature.Articulos}
                         suggestedProducts={feature.Recomendados} feature={feature}/>
        </div>
    );
}

export default observer(HomeScreen);